export enum SponsorTypeLabels {
  Company,
  Individual,
}
